import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Download, Send, ExternalLink } from "lucide-react";

export const PdfPreviewDialog = ({ preview, onClose, onSend }) => {
  const open = !!preview;
  const download = () => {
    const a = document.createElement("a");
    a.href = preview.url; a.download = `${preview.title || "invoice"}.pdf`; a.click();
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="pdf-preview-dialog" className="max-w-4xl w-[96vw] h-[90vh] p-0 gap-0 flex flex-col rounded-none bg-white">
        <DialogHeader className="px-4 sm:px-5 py-3 border-b border-[var(--line)] bg-white flex-row flex-wrap items-center justify-between space-y-0 gap-3 pr-12">
          <div className="min-w-0">
            <DialogTitle className="text-base truncate">Preview · {preview?.title}</DialogTitle>
            <DialogDescription className="text-xs">{preview?.draft ? "Draft — this is exactly how the PDF will look once saved." : "This is the exact PDF your client receives."}</DialogDescription>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <a data-testid="pdf-preview-open-tab" href={preview?.url} target="_blank" rel="noreferrer" title="Open in new tab" className="w-9 h-9 flex items-center justify-center border border-[var(--line)] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors"><ExternalLink className="w-4 h-4" /></a>
            <button data-testid="pdf-preview-download" onClick={download} title="Download" className="w-9 h-9 flex items-center justify-center border border-[var(--line)] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors"><Download className="w-4 h-4" /></button>
            {onSend && preview?.inv && (
              <button data-testid="pdf-preview-send" onClick={() => onSend(preview.inv)} className="h-9 px-4 bg-[#1A1A18] text-white text-sm flex items-center gap-1.5 hover:bg-[var(--accent)] transition-colors"><Send className="w-3.5 h-3.5" /> Email to client</button>
            )}
          </div>
        </DialogHeader>
        {preview && (
          <div data-testid="pdf-preview-pages" className="flex-1 overflow-auto bg-[#525659] p-3 sm:p-6 space-y-4">
            {(preview.pages || []).map((src, i) => (
              <img key={i} data-testid={`pdf-preview-page-${i}`} src={src} alt={`Page ${i + 1}`} className="block mx-auto w-full max-w-[816px] bg-white shadow-xl" />
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
